import { TokenDistributor as TokenDistributorAbi } from '../abis';
import { executeTx, getContract } from '../utils';
export class TokenDistributor {
    constructor(options) {
        this.options = options;
        this.tokenDistributorContract = this.createTokenDistributorContract();
    }
    async claim(recipient, tokenAddresses, tokenAmounts, expiryTime, merkleProofs, gasLimit) {
        const decodedMerkleProofs = merkleProofs.map((e) => e.map(base64ToBytes32));
        const tx = this.tokenDistributorContract.claim(recipient, tokenAddresses, tokenAmounts, expiryTime, decodedMerkleProofs, { gasLimit });
        return executeTx(tx);
    }
    createTokenDistributorContract() {
        return getContract(this.options.address, TokenDistributorAbi, this.options.signerOrProvider);
    }
}
const base64ToBytes32 = (base64String) => {
    const binaryString = atob(base64String);
    const hexArray = Array.from(binaryString, (char) => char.charCodeAt(0).toString(16).padStart(2, '0'));
    let hexString = hexArray.join('');
    if (hexString.length > 64) {
        throw new Error('Input base64 string is too long to convert to bytes32');
    }
    hexString = hexString.padStart(64, '0');
    return '0x' + hexString;
};
